module.exports = __webpack_public_path__ + "img/logo_vives_int.996b5f99.svg";